<template>
    <div>
        <div v-show="!loading">
            <PanZoomComponent v-if="load_panzoom" :svg="svg_loaded" />

            <template v-else>
                <div v-html="svg_loaded"></div>
            </template>

            <template v-if="!loading && load_panzoom">
                <template v-for="zona in zonas">
                    <PopOverComponent :key="zona.id" :zona="zona" :zona_id="zona_id" :config_precios="config_precios" :libres="getAsientosLibres(zona)" :occupied="zona.id === zona_id" />
                </template>
            </template>
        </div>
        <template v-if="loading">
            <div class="col-12 text-center" style="height: 200px">
                <LoaderComponent/>
            </div>
        </template>
    </div>
</template>

<script>
    import PopOverComponent from './components/PopOverComponent';
    import PanZoomComponent from './components/PanZoomComponent';

    export default {

        components : { PopOverComponent, PanZoomComponent },

        props: ['zonas','place', 'place_id', 'sesion_id', 'zona_id', 'svgGeneral' ,'config_precios', 'hovered_zona_id'],
        data() {
            return {
                svg_loaded : '',
                loading: true
            }
        },
        created() {
            if (this.svgGeneral) {
                this.loadSVG(this.svgGeneral);
            } else {
                this.getSvgCode();
            }
        },
        computed: {
            load_panzoom() {
                var load_panzoom = true

                var userAgent = navigator.userAgent || navigator.vendor || window.opera;

                // Windows Phone must come first because its UA also contains "Android"
                if(/windows phone/i.test(userAgent)) {
                    load_panzoom = false;
                }

                if(/android/i.test(userAgent)) {
                    load_panzoom = false;
                }

                // iOS detection from: http://stackoverflow.com/a/9039885/177710
                if(/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    load_panzoom = false;
                }

                return load_panzoom;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            taquilla() {
                var path = this.$router.currentRoute.fullPath;

                return path.includes('admin');
            },
            user() {
                return this.$store.getters.getUser;
            }
        },
        watch: {
            hovered_zona_id(newId, oldId) {
                if (oldId) {
                    const oldRegion = document.querySelector(`[data-region="${oldId}"]`);
                    if (oldRegion) {
                        oldRegion.classList.remove('highlighted-svg');
                    }
                }

                if (newId) {
                    const newRegion = document.querySelector(`[data-region="${newId}"]`);
                    if (newRegion) {
                        newRegion.classList.add('highlighted-svg');
                    }
                }
            },
            zonas: {
                handler(newZonas) {
                    if (this.svg_loaded && newZonas?.length) {
                        this.$nextTick(() => this.processSvg());
                    }
                },
                deep: true
            }
        },
        methods : {
            getAsientosLibres(zona) {
                if (window.location.href.includes('/admin/parcelas')) {
                    return zona.libres;
                }

                if(zona.libres >= 0) {
                    return zona.libres;
                }

                if(zona.libres < 0) {
                    return 0;
                }

                var aforo = 0;

                if(!zona.with_seats) {
                    aforo = zona.aforo;
                } else {
                    aforo = zona.total_asientos;
                }

                aforo = aforo - zona.confirmados - zona.bloqueados - zona.no_confirmados - zona.sesion;

                if(aforo < 0) {
                    aforo = 0;
                }

                return aforo;
            },
            getSvgCode() {
                this.loading = true;

                const params = {
                    filters: {
                        sesion_id: this.sesion_id ? this.sesion_id : null,
                        tid: this.configuracion.hash_teatro,
                        taquilla: this.taquilla
                    },
                    recinto_id: this.place_id ?? this.place?.id,
                    tid: this.configuracion.hash_teatro,
                    taquilla: this.taquilla
                }

                this.$store.dispatch(this.config.getVuexAlias('front.recinto.svg'), params).then(res => {
                    this.$emit('setSvgGeneral', res.data.svg);
                    this.loadSVG(res.data.svg);
                }).catch(err => {
                    console.error('Error al cargar el SVG:', err);
                }).finally(() => {
                    this.loading = false;
                });
            },
            loadSVG(svg) {
                this.svg_loaded = svg;

                var vue_instance = this;
                var attempts = 0;

                var tryProcess = function() {
                    if (!vue_instance.zonas || vue_instance.zonas.length === 0) {
                        if (attempts < 30) {
                            attempts++;
                            setTimeout(tryProcess, 200);
                        }
                        return;
                    }
                    vue_instance.processSvg();
                    vue_instance.loading = false;
                    vue_instance.$emit('cargado');
                };

                setTimeout(tryProcess, 1000);
            },
            processSvg() {
                var self = this;
                var regions = document.getElementsByClassName("recinto-zona");

                for (var n = 0; n < regions.length; n++) {
                    if (regions[n].dataset !== undefined) {
                        regions[n].classList.add("no-disponible");
                    }
                }

                for (var i = 0; i < regions.length; i++) {
                    if (regions[i].dataset !== undefined) {
                        var region_id = regions[i].dataset.region;

                        regions[i].addEventListener('mouseenter', function() {
                            self.$emit('zoneHover', Number(region_id), true);
                        }, false);

                        regions[i].addEventListener('mouseleave', function() {
                            self.$emit('zoneHover', Number(region_id), false);
                        }, false);

                        for (var j = 0; j < this.zonas.length; j++) {
                            if (this.zonas[j].id == region_id && typeof this.zonas[j].esta_disponible !== 'undefined') {
                                if (this.zonas[j].esta_disponible) {
                                    regions[i].classList.remove("no-disponible");
                                }
                            }
                        }

                        if (this.user && this.user.role === 11) {
                            if (this.user.regions.some(function(objeto) { return objeto.id === Number(region_id); })) {
                                regions[i].addEventListener('click', function() {
                                    self.clickRegion(this.dataset.region);
                                }, false);
                            }
                        } else {
                            regions[i].addEventListener('click', function() {
                                self.clickRegion(this.dataset.region);
                            }, false);
                        }
                    }
                }
            },
            clickRegion : function(region_id) {
                let zona = null;
                for (let i = 0; i < this.zonas.length; i++) {
                    if (this.zonas[i].id == region_id) {
                        zona = this.zonas[i];
                    }
                }

                if(zona) {
                    const puedeContinuar = zona.precios ? zona.precios.length > 0 : true;
                    if(this.$route.name === 'back.events.sesion.bloquear-asientos' || this.$route.name === 'back.abonos.bloquear-asientos' || this.$route.name === 'back.abonos.index' || this.$route.name === 'back.abonados.show'  || this.$route.name === 'back.events.venta' || this.$route.name === 'superadmin.butacas.ocultar' || this.$route.name === 'back.abonos.precios' || this.$route.name === 'back.events.sesion.configuracion' || this.$route.name === 'back.precios.parcelas.index') {
                        this.$emit('clickZona', zona);
                    } else if(zona.esta_disponible && this.getAsientosLibres(zona) > 0 && puedeContinuar) {
                        this.$emit('clickZona', zona);
                    }
                }
            },
        }
    }
</script>

<style>
.recinto-zona.highlighted-svg {
    fill: var(--altcolor) !important;
    stroke: var(--alttextcolor);
    stroke-width: 3px;
    transition: fill 0.2s, opacity 0.2s, stroke 0.2s;
}
</style>
